import React from "react";
import Svg, { Path, Defs, LinearGradient, Stop } from "react-native-svg";
import { uniqueId } from "lodash";

export default function ArchiveElemenstIcon() {
  const filterId = "paint0_linear_archive" + uniqueId();
  const gradientId = "paint1_linear" + uniqueId();
  const filterUrl = "url(#" + filterId + ")";
  const gradientUrl = "url(#" + gradientId + ")";

  return (
    <Svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M24.9167 4.33333H18.4167V2.70833C18.4167 2.42102 18.4631 1.40062 17.875 0.8125C17.2869 0.224382 15.9957 0 15.7083 0H10.2917C10.0043 0 8.81478 0.122731 8.125 0.8125C7.43522 1.50227 7.58333 2.42102 7.58333 2.70833V4.33333H1.08333C0.796015 4.33333 0.520465 4.44747 0.317301 4.65063C0.114137 4.8538 0 5.12935 0 5.41667C0 5.70398 0.114137 5.97953 0.317301 6.1827C0.520465 6.38586 0.796015 6.5 1.08333 6.5H24.9167C25.204 6.5 25.4795 6.38586 25.6827 6.1827C25.8859 5.97953 26 5.70398 26 5.41667C26 5.12935 25.8859 4.8538 25.6827 4.65063C25.4795 4.44747 25.204 4.33333 24.9167 4.33333ZM9.75 3.16667C9.75 2.61438 10.1977 2.16667 10.75 2.16667H15.25C15.8023 2.16667 16.25 2.61438 16.25 3.16667V4.33333H9.75V3.16667Z"
        fill={filterUrl}
      />
      <Path
        d="M3.25 8.66602V22.7493C3.25 23.6113 3.59241 24.438 4.2019 25.0474C4.8114 25.6569 5.63805 25.9993 6.5 25.9993H19.5C20.362 25.9993 21.1886 25.6569 21.7981 25.0474C22.4076 24.438 22.75 23.6113 22.75 22.7493V8.66602H3.25ZM17.7818 20.5664L16.25 22.0993L13 18.8493L9.75 22.0993L8.21817 20.5664L11.4682 17.3164L8.21817 14.0664L9.75 12.5346L13 15.7846L16.25 12.5346L17.7818 14.0664L14.5318 17.3164L17.7818 20.5664Z"
        fill={gradientUrl}
      />
      <Defs>
        <LinearGradient
          id={filterId}
          x1="-7.2467e-07"
          y1="1.40964"
          x2="0.955289"
          y2="9.21744"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stopColor="#2AE8CB" />
        </LinearGradient>
        <LinearGradient
          id={gradientId}
          x1="3.25"
          y1="12.4251"
          x2="10.9802"
          y2="30.1947"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#05858A" />
          <Stop offset="1" stopColor="#2AE8CB" />
        </LinearGradient>
      </Defs>
    </Svg>
  );
}
